module.exports = __webpack_public_path__ + "img/main-logo.7f0be726.png";